import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';

// The signed-in pages outside the editor (profile landing, My comments) under the shared header
// bar (#959). Kept small on purpose (ADR 0006 (b)): the real navigation grows with the
// profile/community tier and the search/explore surfaces.
export function AppChrome() {
  return (
    <div className="app-chrome">
      <SiteHeader />
      <Outlet />
    </div>
  );
}
